export const getTNTIndexableFieldIdsRedux = (
  actionType: string
  ) => {
    window.parent.primingcloudRedux.application.getTNTIndexableFieldIds(
      actionType
    );
}

export const getApplicationMetadataRedux = (
  actionType: string
) => {
    window.parent.primingcloud.application.getApplicationMetadata(
      actionType
    );
}

export const listParameterNamesRedux = (
  allowedDataTypesArray: string[],
  actionType: string
  ) => {
    window.parent.primingcloud.application.listParameterNames(
      allowedDataTypesArray,
      actionType
    )
  
}

export const getDataTypesRedux = (
  actionType: string
) => {
  window.parent.primingcloud.application.getDataTypes(
    actionType
  );
}

export const translateDataTypesRedux = (
  dataType: string,
  actionType: string
) => { 
    window.parent.primingcloud.application.translateDataTypes(
      dataType,
      actionType
    );
}

export const getBusinessObjectPoolIDRedux = (
  poolName: string,
  actionType: string
) => {
    window.parent.primingcloud.application.getBusinessObjectPoolID(
      poolName,
      actionType
    )
}

export const listBusinessobjectPoolNamesRedux = (
  actionType: string
) => {
    window.parent.primingcloud.application.listBusinessobjectPoolNames(
      actionType
    )
}

export const listCatalogsRedux = (
  actionType: string
  ) => {
    window.parent.primingcloud.application.listCatalogs(
      actionType
    )
}

export const loadCatalogRedux = (
  id: number,
  actionType: string
) => {
    window.parent.primingcloud.application.loadCatalog(
      id,
      actionType
    )
}

export const validateDataTypeRedux = (
  dataType: string,
  value: string,
  actionType: string
) => {
  
    window.parent.primingcloud.application.validateDataType(
      dataType,
      value,
      actionType
    )
  
}
